import { Pipe, PipeTransform } from "@angular/core";
import { CommissionRateType } from "../enums/commission-rate-type.enum";

@Pipe({ name: "commissionRateType" })
export class CommissionRateTypePipe implements PipeTransform {
  transform(value: number | undefined | null): string {
    switch (value as CommissionRateType) {
      case CommissionRateType.Percentage:
        return "Percentage";
      case CommissionRateType.Flat:
        return "Flat";
      case CommissionRateType.PercentageFlat:
        return "Percentage + Flat";
      case CommissionRateType.Tiered:
        return "Tiered";
      default:
        return value != null ? String(value) : "—";
    }
  }
}
